import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 获取状态栏高度
export function getStatusBarHeight(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(
    APINames.Native.GET_STATUS_BAR_HEIGHT,
    option
  );
}
